// 가맹점주 내 문의·대화 기록 표시 도우미(한국 시각)
const DOW = { ko: ["일", "월", "화", "수", "목", "금", "토"], zh: ["日", "一", "二", "三", "四", "五", "六"] };
const dow = (lang, i) => (DOW[lang] || DOW.ko)[i];
const KST = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Seoul", year: "numeric", month: "numeric", day: "numeric",
    weekday: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
});
const WD = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

export function fmtAt(iso, lang = "ko") {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const p = Object.fromEntries(KST.formatToParts(d).map((x) => [x.type, x.value]));
    return `${Number(p.month)}/${Number(p.day)} (${dow(lang, WD[p.weekday])}) ${p.hour}:${p.minute}`;
}
export function fmtSchedule(s, lang = "ko") {
    if (!s?.date) return "";
    const [y, m, d] = s.date.split("-").map(Number);
    const w = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
    return `${m}/${d} (${dow(lang, w)})${s.time ? ` ${s.time}` : ""}`;
}
export const isOpen = (st) => st === "new" || st === "processing" || st === "on_hold";
export const stepIndex = (st) => ({ new: 0, processing: 1, completed: 2 }[st] ?? -1);
export const catLabel = (c, lang) => (!c ? "" : (lang === "zh" && c.label_zh) || c.label || "");
export const kindLabel = (item, lang) =>
    [catLabel(item?.category, lang), catLabel(item?.subcategory, lang)].filter(Boolean).join(" · ");
export const bizFmt = (b = "") => b.replace(/^(\d{3})(\d{2})(\d{5})$/, "$1-$2-$3");
export const bizMask = (b = "") => `${b.slice(0, 3)}-${b.slice(3, 5)}-*****`;
export const STATUS_CLASS = { new: "st-new", processing: "st-proc", on_hold: "st-hold", completed: "st-done", canceled: "st-cancel" };
